export const migrationDashboardPath = "/alloy/migration"
export const migrationStatusPath = "/alloy/migration/status"
export const migrationPlanPath = "/alloy/migration/plan/:orgCode"

export const buildPlanPath = orgCode => `/alloy/migration/plan/${orgCode}`
